package dev.lingvo.shared

import kotlinx.serialization.Serializable

/** Only these bounded screenshot events can be selected by screenshot notification preferences. */
val screenshotNotificationEvents: List<WebhookEvent> = listOf(
    WebhookEvent.SCREENSHOT_CAPTURE_CURRENT,
    WebhookEvent.SCREENSHOT_CAPTURE_STALE,
    WebhookEvent.SCREENSHOT_SET_APPROVED,
    WebhookEvent.SCREENSHOT_PUSH_SUCCEEDED,
    WebhookEvent.SCREENSHOT_PUSH_FAILED,
    WebhookEvent.SCREENSHOT_SNAPSHOT_NAMED,
)

/** Email starts opt-in; a member may select only their own subscriptions. */
@Serializable
data class ShotNotificationPreferencesDto(val emailEvents: List<WebhookEvent> = emptyList())

/** Workspace controls additionally gate existing endpoint subscriptions and personal opt-ins. */
@Serializable
data class ShotNotificationWorkspacePreferencesDto(
    val emailEnabled: Boolean = true,
    val webhookEvents: List<WebhookEvent> = screenshotNotificationEvents,
)
